import React from 'react';
import '../Style/Dot.css';

const Dot = ({color, size, position}) => <div className={`dot dot-${color} dot-${size} dot-${position}`}></div>;

export default Dot;
